export var Literal = 'Literal';
export var Identifier = 'Identifier';
